import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import { getProfileInfo, updateProfile } from "../../store/actions/customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import AccountWidget from "../../components/shared/AccountWidget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";
import { Link } from "react-router-dom";
import styles from "../../thema/style";
import "../../styles/ModernProfile.css";
import { formatPhoneDisplay, formatPhoneInput, formatPhoneForDatabase, handlePhoneChange } from "../../helpers/phoneFormatter";

class Profile extends Component {
  state = {
    email: "",
    full_name: "",
    phone: "",
    errors: []
  };

  componentDidMount() {
    this.props.getProfileInfo(data => {
      this.setState({
        email: data.email,
        full_name: data.full_name,
        phone: data.phone
      });
    });
  }

  renderErrorMessage() {
    if (this.props.customer.errors.length > 0) {
      return (
        <div className="modern-error-alert">
          <h4 className="alert-heading">
            <FontAwesomeIcon icon="exclamation-triangle" />
            Hata Meydana Geldi!
          </h4>
          <ul>
            {this.props.customer.errors.map((error, i) => (
              <li key={i}>{error.message}</li>
            ))}
          </ul>
        </div>
      );
    }

    if (this.state.errors.length > 0) {
      return (
        <div className="modern-error-alert">
          <h4 className="alert-heading">
            <FontAwesomeIcon icon="exclamation-triangle" />
            Hata Meydana Geldi!
          </h4>
          <ul>
            {this.state.errors.map((error, i) => <li key={i}>{error}</li>)}
          </ul>
        </div>
      );
    } else {
      return null;
    }
  }

  validate = () => {
    const errors = [];
    if (!this.state.full_name)
      errors.push("Adınız Soyadınız alanı boş bırakılamaz!");
    if (!this.state.email) errors.push("E-Mail alanı boş bırakılamaz!");
    return errors;
  };

  handleChange = e => {
    if (e.target.name === 'phone') {
      handlePhoneChange(e, this.setState.bind(this));
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  onSubmit = e => {
    e.preventDefault();
    var errors = this.validate();
    this.setState({ errors: errors });
    if (errors.length === 0) {
      this.props.updateProfile({ ...this.state });
    }
  };

  render() {
    if (this.props.customer.fetching) {
      return (
        <div className="modern-profile-container">
          <div className="container">
            <div className="profile-loading">
              <div className="profile-loading-spinner"></div>
              <div className="profile-loading-text">Sayfa Yükleniyor...</div>
            </div>
          </div>
        </div>
      );
    } else {
      if (!this.props.customer.customer) {
        return (
          <Redirect
            to={{
              pathname: "/giris-yap"
              // state: { referrer: currentLocation }
            }}
          />
        );
      }
      if (!this.props.customer.profile) {
        return (
          <div className="modern-profile-container">
            <div className="container">
              <div className="profile-loading">
                <div className="profile-loading-spinner"></div>
                <div className="profile-loading-text">Profil Bilgileri Yükleniyor...</div>
              </div>
            </div>
          </div>
        );
      }
      return (
        <React.Fragment>
          <PageTitle title={"Profilimi Düzenle"} />
          <div className="modern-profile-container">
            <div className={"container"}>
              <div className="row">
                <div className={"col-md-9"}>
                  {/* Modern Header */}
                  <div className="modern-profile-header">
                    <div className="profile-header-content">
                      <h1 className="profile-title">
                        <FontAwesomeIcon icon="user-edit" />
                        Profilimi Düzenle
                      </h1>
                      <p className="profile-subtitle">
                        Hesap bilgilerinizi güncelleyin ve yönetin
                      </p>
                      <div className="profile-breadcrumb">
                        <Link to="/hesabim">Hesabım</Link>
                        {" / "}
                        <span>Profilimi Düzenle</span>
                      </div>
                    </div>
                  </div>

                  {/* Error Messages */}
                  {this.renderErrorMessage()}

                  {/* Success Message */}
                  {this.props.customer.success && (
                    <div className="modern-success-alert">
                      <div className="success-icon">
                        <FontAwesomeIcon icon="check-circle" />
                      </div>
                      <span>Profiliniz başarıyla güncellendi!</span>
                    </div>
                  )}

                  {/* Profile Form Card */}
                  <div className="modern-profile-form-card">
                    <div className="profile-form-header">
                      <div className="profile-form-icon">
                        <FontAwesomeIcon icon="user-cog" />
                      </div>
                      <div className="profile-form-header-text">
                        <h3>Kişisel Bilgiler</h3>
                        <p>Hesap bilgilerinizi aşağıdaki form ile güncelleyebilirsiniz</p>
                      </div>
                    </div>

                    <form className="modern-profile-form" onSubmit={this.onSubmit}>
                      <div className="profile-form-group">
                        <label className="profile-form-label">Adınız Soyadınız</label>
                        <div className="profile-input-with-icon">
                          <div className="profile-input-icon">
                            <FontAwesomeIcon icon="user" />
                          </div>
                          <input
                            type="text"
                            className="profile-form-control"
                            name="full_name"
                            defaultValue={this.state.full_name}
                            placeholder="Adınız ve soyadınızı giriniz"
                            onChange={e => {
                              this.handleChange(e);
                            }}
                            required
                          />
                        </div>
                      </div>

                      <div className="profile-form-group">
                        <label className="profile-form-label">E-Mail Adresiniz</label>
                        <div className="profile-input-with-icon">
                          <div className="profile-input-icon">
                            <FontAwesomeIcon icon="envelope" />
                          </div>
                          <input
                            type="email"
                            className="profile-form-control"
                            name="email"
                            defaultValue={this.state.email}
                            placeholder="E-mail adresinizi giriniz"
                            onChange={e => {
                              this.handleChange(e);
                            }}
                            required
                          />
                        </div>
                      </div>

                      <div className="profile-form-group">
                        <label className="profile-form-label">Telefon Numaranız</label>
                        <div className="profile-input-with-icon">
                          <div className="profile-input-icon">
                            <FontAwesomeIcon icon="phone" />
                          </div>
                          <input
                            type="text"
                            className="profile-form-control"
                            name="phone"
                            value={formatPhoneDisplay(this.state.phone)}
                            placeholder="555 555 55 55"
                            maxLength="13"
                            onChange={e => {
                              this.handleChange(e);
                            }}
                          />
                        </div>
                      </div>

                      <div className="profile-form-actions">
                        <button
                          type="button"
                          className="profile-action-btn profile-cancel-btn"
                          onClick={e => {
                            e.preventDefault();
                            this.props.history.push("/hesabim");
                          }}
                        >
                          <FontAwesomeIcon icon="times" />
                          İptal Et
                        </button>
                        <button
                          type="submit"
                          className="profile-action-btn profile-save-btn"
                          disabled={this.props.customer.updating}
                        >
                          {this.props.customer.updating ? (
                            <React.Fragment>
                              <FontAwesomeIcon icon="spinner" spin />
                              Güncelleniyor...
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <FontAwesomeIcon icon="save" />
                              Profilimi Güncelle
                            </React.Fragment>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className={"col-md-3"}>
                  <AccountWidget />
                  <CategoriesWidget />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { getProfileInfo, updateProfile };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);



// WEBPACK FOOTER //
// ./src/routers/Account/profile.js